export default [
  {
    path: '/admin/reports/sale/visitation-plans',
    name: 'visitation-plan',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/sale/visitation-plan.vue')
  },
  {
    path: '/admin/reports/sale/detail-sale-by-products',
    name: 'detail-sale-by-product',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/sale/detail-sale-by-product.vue')
  },
  {
    path: '/admin/reports/sale/detail-stock-return-by-products',
    name: 'detail-stock-return-by-product',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/sale/detail-stock-return-by-product.vue')
  },
  {
    path: '/admin/reports/sale/detail-sale-by-customers',
    name: 'detail-sale-by-customer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/sale/detail-sale-by-customer.vue')
  },
  {
    path: '/admin/reports/sale/detail-sale-by-imeis',
    name: 'detail-sale-by-imei',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/sale/detail-sale-by-imei.vue')
  },
  {
    path: '/admin/reports/sale/quarterly-sale-product-by-customers',
    name: 'quarterly-sale-product-by-customer',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/sale/quarterly-sale-product-by-customer.vue')
  }
]